import { render, staticRenderFns } from "./NestedListItem.vue?vue&type=template&id=8e3c06d4"
import script from "./NestedListItem.vue?vue&type=script&lang=js"
export * from "./NestedListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports